export const LOGIN = "/login";
export const FORGET_PASSWORD = "/user/forgot-password";
export const RESET_PASSWORD = "/api/user/reset-password";
export const UPDATE_USER_DETAILS = "/api/user";
export const GET_USER_DETAILS = "/api/user/profile";
export const ADMIN_USER_API = "/api/staff";
export const KIT_INFO_API = "/api/kits";
export const KIT_QUANTITY_SUMMARY_API = "/api/kits/quantity-summary";
export const LOGOUT_API = "/api/logout";
export const ENCRYPT_PRODUCT_API = "/encrypt-product";
export const VERIFY_PRODUCT_API = "/verify-product";
export const ORDER_PAYMENT_API = "/order-payment";
export const PAYMENT_STATUS_API = "/payment/status";
export const CUSTOMER_DETAILS_API = "/api/customers";
export const ORDER_DETAILS_API = "/api/orders";
export const NOTIFICATION_API = "/api/notifications";
export const FETCH_LATEST_NOTIFICATION_API = "/api/notifications/latest";
export const FETCH_QUANTITY_DISCOUNT_API = "/quantity-discounts";
export const VERIFY_BARCODE_API = "/verify-barcode";
export const KIt_REGISTER_API = "/kit-register";
export const KIT_REGISTERED_FETCHED_API = "/api/patients-list";
export const PATIENT_STATUS_UPDATE_API = "/api/patients";
export const GLOBAL_BARCODE_SEARCH_API = "/api/barcodes";
export const FETCHED_LAB_LIST = "/api/labs";


